import {
  jb_radio_css_default
} from "./chunk.J5MYUZIG.js";
import {
  l
} from "./chunk.VGR3SD7Z.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.TQSPBGH7.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r,
  r2
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-radio/jb-radio.ts
var JbRadio = class extends Initiable(FormElement(i)) {
  constructor() {
    super(...arguments);
    this._index = 0;
  }
  async firstUpdated() {
    await this.updateComplete;
    if (this.value) {
      this._index = parseInt(this._selectedElement.dataset.index || "0", 10);
    }
  }
  _handleInputChange(e3) {
    this._index = parseInt(e3.target.dataset.index || "0", 10);
    this.value = e3.target.value;
  }
  _handleKeyDown(e3) {
    const optionElements = this._optionElements;
    switch (e3.code) {
      case "Space":
      case "Enter":
        e3.target.click();
        e3.preventDefault();
        break;
      case "ArrowLeft":
      case "ArrowUp":
        e3.preventDefault();
        this._index -= 1;
        if (this._index < 0) {
          this._index = this.options.length - 1;
        }
        optionElements[this._index].focus();
        optionElements[this._index].click();
        break;
      case "ArrowRight":
      case "ArrowDown":
        e3.preventDefault();
        this._index += 1;
        if (this._index >= this.options.length) {
          this._index = 0;
        }
        optionElements[this._index].focus();
        optionElements[this._index].click();
        break;
      case "Backspace":
      case "Delete":
        if (!this.requiredText) {
          if (this._selectedElement) {
            this.value = "";
            this._index = 0;
          }
        }
        break;
      default:
        break;
    }
  }
  render() {
    return b`
      <div
        class="${e2({ error: !!this.errorText || this.showError, disabled: !!this.disabled })}"
        data-fly-tweak="10,-10,20,0"
      >
        ${this.label ? b`<label class="main">${this.label}${this.requiredText ? "*" : ""}</label>` : A}
        <div
          class="radios"
          role="radiogroup"
          aria-label="${this.label}"
          aria-invalid="${this.showError || this.errorText ? "true" : "false"}"
          aria-errormessage=${this.showError || !!this.errorText ? `${this.name}_error` : A}
          aria-required=${!!this.requiredText}
          @focusin=${() => {
      if (!this.value && this.requiredText) {
        this._optionElements[this._index].click();
      }
    }}
        >
          ${this.options.map(
      (option, index) => b`
              <label>
                <input
                  data-index="${index}"
                  .value=${option.value}
                  type="radio"
                  name="${this.name}"
                  .checked=${l(option.value === this.value)}
                  ?required=${!!this.requiredText}
                  ?disabled=${this.disabled}
                  @change=${this._handleInputChange}
                  aria-label="${option.label}"
                  aria-checked="${option.value === this.value}"
                />
                <p
                  tabindex="${this._index === index || option.value === this.value ? "0" : "-1"}"
                  @keydown=${this._handleKeyDown}
                >
                  ${option.label}
                </p>
              </label>
            `
    )}
        </div>
        <div id="${this.name}_error">
          ${this.showError ? b`<p class="error">${this.requiredText}</p>` : A}
          ${this.errorText ? b`<p class="error">${this.errorText}</p>` : A}
        </div>
      </div>
    `;
  }
};
JbRadio.styles = [reset_css_default, jb_radio_css_default];
JbRadio.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Array })
], JbRadio.prototype, "options", 2);
__decorateClass([
  r()
], JbRadio.prototype, "_index", 2);
__decorateClass([
  r2("label p")
], JbRadio.prototype, "_optionElements", 2);
__decorateClass([
  e("input:checked")
], JbRadio.prototype, "_selectedElement", 2);
JbRadio = __decorateClass([
  customElement("jb-radio")
], JbRadio);

export {
  JbRadio
};
